import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import Address from "~/models/Address";
import DisplayAddress from "../Address/DisplayAddress";

const DisplayTitle = observer(({ title, address }) => {
  return title || <DisplayAddress address={address} />;
});

DisplayTitle.propTypes = {
  title: PropTypes.string,
  address: PropTypes.instanceOf(Address),
};

export default DisplayTitle;
